import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { AuthenticationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ProductModel } from 'app/models';
import { ProductCardModel, ProductCardComponent } from 'lib/ng2-sapmp/src/ui-components/product-card';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { BrowseService } from './shared';
import { BREADCRUMBS } from 'config';
import { HeaderService } from './../header/header.service';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var ENV_PORTAL: any;

@Component({
  selector: 'app-browse',
  providers: [BrowseService],
  templateUrl: './browse.component.html',
  styleUrls: ['./browse.component.scss']
})
export class BrowseComponent implements OnInit, OnDestroy {

  productList: Array<ProductModel>;
  columnCount: string;
  breadCrumbs: BreadCrumbModel[];
  cardDetails: ProductCardModel[];
  pivots: Array<MobilePivotModel>;
  isFn: boolean = (ENV_PORTAL === 'fnabc') ? true : false;
  pageTitle: string;
  errorMessage: string;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private browseService: BrowseService,
    private utilityService: UtilityService,
    private http: HttpClient, private breadCrumbService: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService, private headerService: HeaderService) {
    this.cardDetails = [];
    this.pivots = new Array<MobilePivotModel>();
  }

  ngOnInit() {
    this.headerService.setCondensedFooterStatus(false);
    this.headerService.condensedHeader('browse');
    this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
    this.pageTitle = (ENV_PORTAL === 'fnabc') ? 'FirstNet Apps & Solutions ' : 'Marketplace';
    this.pivots.push({ label: this.pageTitle, routerLink: '/browse' });
    this.pivots.push({ label: 'Home', routerLink: '/home' });
    if (ENV_PORTAL === 'fnabc') {
      this.breadCrumbService.setCurrentBreadCrumb({ label: 'FirstNet Apps & Solutions', routerLink: '/browse' });
    } else {
      this.breadCrumbService.setCurrentBreadCrumb({ label: 'Marketplace', routerLink: '/browse' });
    }
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    document.body.classList.add('browse-page');
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.browseService.browseProducts(this.utilityService.getEnvConfig().catalogServiceUrl)
      .subscribe(respobj => {
        this.productList = respobj;
        this.createCardConfig(this.productList);
      }, error => {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);
      });

    this.browseService.createPageLoadProperties();

    // Dynamic column values settings.
    if (this.utilityService.getEnvConfig().catalogColumnCount) {
      this.columnCount = 'catalog' + this.utilityService.getEnvConfig().catalogColumnCount + 'column';
    } else {
      this.columnCount = '';
    }
  };

  ngOnDestroy() {
    document.body.classList.remove('browse-page');
  }

  handleError(error) {
    if (error) {
      this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
      this.utilityService.loadFocusOnTop();
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse',
        error.status === 400 ? 'Failure_BusinessRule' : undefined);
    } else {
      throw error;
    }
  }

  createCardConfig(products) {
    const sortedProducts: Array<ProductModel> = products.sort((obj1, obj2) => {
      if (obj1.displayName.toLowerCase() > obj2.displayName.toLowerCase()) {
        return 1;
      }
      if (obj1.displayName.toLowerCase() < obj2.displayName.toLowerCase()) {
        return -1;
      }
      return 0;
    });
    for (const product of sortedProducts) {
      const card = new ProductCardModel();
      card.activetab = product.active;
      card.cardTitle = product.displayName;
      card.description = product.shortDisplayInfo;
      console.log(product);
      if (product.skus && product.skus && product.skus[0].basicPrice) {
        card.price = product.skus[0].basicPrice;
      } else {
        card.price = '0';
      }
      card.imageSrc = product.media.thumbnailurl;
      card.smallImageSrc = product.media.smallThumbnailUrl;
      card.link = '/browse/details/' + product.id;
      this.cardDetails.push(card);
    }

  }

}

